import React, { Component } from 'react';
import { bool, func, shape, string } from 'prop-types';
import { connect } from 'react-redux';

import { deleteNote, openNoteEditor } from 'PipeRouter';
import AffordancesViews from './views';


class Affordances extends Component {
  removeNote = () => {
    const { deleteNote, selectedHighlight } = this.props;

    deleteNote(selectedHighlight);
  }

  render() {
    const { isOpen, markers, openNoteEditor, selectedHighlight } = this.props;

    if (!isOpen) {
      return null;
    }

    const viewOptions = {
      openNoteEditor,
      markers,
      removeNote: this.removeNote,
      selectedHighlight
    };

    return <AffordancesViews { ...viewOptions } />;
  }
}

Affordances.propTypes = {
  isOpen: bool,
  removeNote: func,
  selectedHighlight: shape({
    color: string.isRequired,
    label: string.isRequired,
    markerId: string.isRequired,
    id: string,
    noteText: string,
    lastModifiedAt: string
  })
};


function mapStateToProps(state) {
  return {
    selectedHighlight: state.selectedHighlight,
    markers: state.markers
  };
}

export default connect(mapStateToProps, {
  deleteNote,
  openNoteEditor
})(Affordances);
